import { Component, Input } from '@angular/core';
import * as _ from 'lodash';


@Component({
  moduleId: module.id,
  selector: 'scorecard-item-header',
  templateUrl: 'scorecard-item-header.component.html',
  styleUrls: ['scorecard-item-header.component.scss'],
})
export class ScorecardItemHeaderComponent {
  @Input() valid: number|boolean; // 1|0 indicate valid or invalid
  @Input() populated: number|boolean; // 1|0 indicate has valie or not
  @Input() path: string; // path to field
  @Input() fieldMap: string;
  @Input() collapsible: boolean = true; // can collapse content or not
  @Input() title: string;
  @Input() score: number; // Total number of valid fields
  @Input() possible: number; // Total number of fields
  @Input() collapsed: boolean;
  @Input() bold: boolean;
  @Input() hasTooltip: boolean = false; // adds tooltip to the header
  @Input() badgeNumber: number;
  @Input() badgeColor: string = 'darkred';

  get completePercentage(): number|null {
    if (_.isNil(this.possible)) { return null; }
    if (this.score === 0 && this.possible === 0) { return 100; }
    return Math.floor((this.score / this.possible) * 100);
  }

  get scorecardStatusTitle(): string {
    if (!this.populated) {
      return 'Missing';
    } else if (this.valid) {
      return 'Valid';
    } else {
      return 'Invalid';
    }
  }

  get tooltipHTML(): string {
    return `
      <div class='scorecard-tooltip-text'>
        <strong class='scorecard-tooltip-status'>
          ${this.scorecardStatusTitle}
        </strong>
        <span class='scorecard-tooltip-note'>
          Click to jump to field
        </span>
      </div>
    `;
  }
}
